import { ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./Layouts/HomePage";
import theme from "./theme/index";
import Header from "./Components/Header";
import FirebaseContext from "./Context/firebase";
import { firebase } from "./lib/firebase";
import ProjectsPage from "./Layouts/ProjectsPage";
import { GlobalProvider } from "./Components/GlobalContext";
import BlogsPage from "./Layouts/BlogsPage";

function App() {
  return (
    <FirebaseContext.Provider value={{ firebase }}>
      <ChakraProvider theme={theme}>
        <GlobalProvider>
          <Router>
            <Header />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/blogs" element={<BlogsPage />} />
            </Routes>
          </Router>
        </GlobalProvider>
      </ChakraProvider>
    </FirebaseContext.Provider>
  );
}

export default App;
